
import { defineComponent, PropType } from 'vue';
import { VisibilityGrid } from '@/constants/VisibilityGrid';
import GridRowCell from './GridRowCell.vue';
import GridRowData from '@/models/grid/GridRowData';
import GridRowCellData, { getRowVisibilityState, normalizeRowVisibilityKey } from '@/models/grid/GridRowCellData';
import { formFieldsStoreV36 } from '@/store';

export default defineComponent({
    components: {
        GridRowCell
    },
    emits: ['toggle-row-visibility'],
    props: {
        rowData: {
            type: Object as PropType<GridRowData>,
            required: true
        },
        rowVisibilityByGroup: {
            type: Object as PropType<Record<string, boolean>>,
            required: true
        },
        isSubject: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        cellDatas(): GridRowCellData[] {
            return this.rowData.cells;
        },
        photoRow(): boolean {
            return this.rowData.photoRow;
        },
        rowVisibilityGroupKey(): string {
            return normalizeRowVisibilityKey(this.rowData.fieldName);
        },
        isRowVisible(): boolean {
            const storeState = getRowVisibilityState(this.rowData.fieldName, formFieldsStoreV36.RowVisibilityGrid);

            if (storeState === VisibilityGrid.AlwaysOn || storeState === VisibilityGrid.Hidden) {
                return false;
            }

            if (storeState === VisibilityGrid.Visible) {
                return true;
            }

            // 'default' means no server override, so use the locally toggled state.
            return this.rowVisibilityByGroup[this.rowVisibilityGroupKey] ?? true;
        }
    }
});
